import React from "react";
import RechercherUtilisateurs from "./RechercheUtilisateur";
import Libelle from "../../_i18n/fr.json";
import Layout from "../../components/Layout";

function UtilisateurPage() {
  return (
    <React.Fragment>
      <Layout title={Libelle.pageUtilisateurs.titre}>
        <div>
          <RechercherUtilisateurs />
        </div>
      </Layout>
    </React.Fragment>
  );
}

export default UtilisateurPage;
